import React, { useState, useEffect } from "react";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import { MdOutlineSearch } from "react-icons/md";

const ExercisesPage = () => {
  const navigate = useNavigate();
  const [exercisesarray, setexercisesarray] = useState([]);
  const [si, setsi] = useState(-1);
  const [ei, setei] = useState(-1);
  const [temp, settemp] = useState(0);
  const [page, setpage] = useState(0);

  async function fetchExercises() {
    const options = {
      method: "GET",
      url: "https://exercisedb.p.rapidapi.com/exercises",
      params: { limit: "150" },
      headers: {
        "X-RapidAPI-Key": "a768ccb462mshb6fc37b5af55038p107e38jsn89c8bfa2c507",
        // 'X-RapidAPI-Key': '8f34428108msh6dbce8077b032eap1f916fjsn462f4690f7be',
        "X-RapidAPI-Host": "exercisedb.p.rapidapi.com",
      },
    };
    try {
      const response = await Axios.request(options);
      setexercisesarray(response.data);
      setsi(0);
      if (response.data.length < 9) setei(response.data.length);
      else setei(9);
      settemp(temp + 1);
      setpage(1);
    } catch (error) {
      console.error(error);
    }
  }

  function displayExercises() {
    let exercise_cards = document.getElementById("exercise-cards");
    exercise_cards.innerHTML = "";
    for (let i = si; i < ei; i++) {
      let exercise_card = document.createElement("div");
      exercise_card.className = "exercise-card";
      exercise_card.onclick = () => {
        navigate(`/exercises/${exercisesarray[i].id}`);
      };
      let exercise_image = document.createElement("img");
      exercise_image.src = exercisesarray[i].gifUrl;
      exercise_image.alt = "exercise-image";
      exercise_card.appendChild(exercise_image);
      let exercise_title = document.createElement("h2");
      exercise_title.className = "exercise-title";
      let textname = exercisesarray[i].name;
      textname = textname.slice(0, 20);
      if (textname.length >= 20) textname = textname.concat(" ...");
      exercise_title.innerText = textname;
      exercise_card.appendChild(exercise_title);
      exercise_cards.appendChild(exercise_card);
    }
  }

  useEffect(() => {
    fetchExercises();
  }, []);

  useEffect(() => {
    displayExercises();
  }, [temp]);

  async function fetchExercisesBP() {
    let bodypart = document.getElementById("search-input").value;
    const options = {
      method: "GET",
      url: `https://exercisedb.p.rapidapi.com/exercises/bodyPart/${bodypart}`,
      params: { limit: "20" },
      headers: {
        "X-RapidAPI-Key": "a768ccb462mshb6fc37b5af55038p107e38jsn89c8bfa2c507",
        // 'X-RapidAPI-Key': '8f34428108msh6dbce8077b032eap1f916fjsn462f4690f7be',
        "X-RapidAPI-Host": "exercisedb.p.rapidapi.com",
      },
    };
    try {
      const response = await Axios.request(options);
      setexercisesarray(response.data);
      console.log("Testing2");
      setsi(0);
      if (response.data.length < 9) setei(response.data.length);
      else setei(9);
      settemp(temp + 1);
      setpage(1);
    } catch (error) {
      console.error(error);
    }
  }

  const left = () => {
    if (exercisesarray.length != 0 && si != 0) {
      setei(si);
      setsi(si - 9);
      settemp(temp + 1);
      setpage(page - 1);
    }
  };
  const right = () => {
    // if(page===Math.ceil(exercisesarray.length/9)-1){
    //   document.getElementById('right-btn').disabled='false';
    // }
    if (exercisesarray.length != 0 && ei != exercisesarray.length) {
      setsi(ei);
      if (exercisesarray.length - ei < 9) setei(exercisesarray.length);
      else setei(ei + 9);
      settemp(temp + 1);
      setpage(page + 1);
    }
  };

  return (
    <section>
      <div className="exercises-container" id="scroll-to-exercises">
        <h2 className="main-heading">Awesome Exercise you should know</h2>
        <div className="search-box">
          <input type="text" id="search-input" placeholder="Search Exercises" />
          <button
            id="search-btn"
            type="button"
            onClick={() => {
              fetchExercisesBP();
            }}
          >
            <MdOutlineSearch className="search-icon" />
          </button>
        </div>

        <div id="exercise-cards" className="exercise-cards"></div>

        <div className="paging">
          <button
            className="paging-btn"
            id="left-btn"
            type="button"
            onClick={left}
            disabled={page === 1}
          >
            &larr;
          </button>
          {/* <p>{page} {Math.ceil(exercisesarray.length/9)}</p> */}
          <p>{page} </p>
          <button
            className="paging-btn"
            id="right-btn"
            type="button"
            onClick={right}
            disabled={page == Math.ceil(exercisesarray.length / 9)}
          >
            &rarr;
          </button>
        </div>
      </div>
    </section>
  );
};

export default ExercisesPage;
